<template>
  <ring-loader
    class="loader-centerscreen"
    :loading="loading"
    :color="spinnerStyle.spinnerColor"
    :size="spinnerStyle.spinnerSize"
  />
</template>

<script>
import spinnerStyle from "@/theme/spinner";
import RingLoader from "vue-spinner/src/RingLoader";

export default {
  name: "SpinnerLoader",
  props: ["loading"],
  components: {
    RingLoader
  },
  data() {
    return {
      spinnerStyle: spinnerStyle
    };
  }
};
</script>

<style>
  .loader-centerscreen {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
</style>
